@if (buttonToggleForm) {
  <form [formGroup]="buttonToggleForm">
    <div fxLayout="row wrap">
      <prism-ui-form-field
        [isValid]="formControlUtilitiesService.isControlValid(buttonToggleForm, controlName)"
        [formFieldItemsCount]="yesNoRadioButtonOptions.length"
        key-id="genderRadio"
        orientation="horizontal"
        >
        <span slot="label">{{controlLabel}}</span>
        <span slot="error">This field is required.</span>
      </prism-ui-form-field>
      <div class="dualRadioHorizontal">
        @for (opt of yesNoRadioButtonOptions; track opt; let index = $index) {
          <div id="{{controlName}}-{{ index }}" formArrayName="{{controlName}}" slot="input-{{ index + 1 }}">
            <prism-ui-radio-button
              labelText="{{opt.label}}"
              [keyId]="controlName + opt.name"
              ngDefaultControl
              [name]="controlName + opt.name"
              formControlName="{{ controlName + index }}"
              [checked]="buttonToggleForm.get(controlName).value === opt.name"
              (prismUiRadioButtonOnChange)="logRadioChangeEvent(controlName, opt.name)"
              >
            </prism-ui-radio-button>
          </div>
        }
      </div>
      @if (buttonToggleForm.get(controlName).value === additionalDetailsAnswer) {
        @for (add of additionalDetails; track add) {
          <app-generic-form [control]="add" [parentForm]="parentForm"></app-generic-form>
        }
      }
    </div>
  </form>
}